<section class="px-4 websites_managment">
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex page_header">
      <button class="back_icon me-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h3 translate class="m-0 ms-2 page_header_title">Website Banner</h3>
    </div>
    <div>
      <div class="d-flex gap-2">
        <button
          mat-stroked-button
          color="primary"
          (click)="toggleReorderMode()"
          [disabled]="isLoading"
        >
          <ng-container *ngIf="!isLoading">
            <span *ngIf="!reorderMode">
              <i class="fa-solid fa-line-height"></i>
            </span>
            <span *ngIf="reorderMode">
              <i class="fa-solid fa-check"></i>
            </span>
          </ng-container>
          <!-- <mat-icon *ngIf="!isLoading">{{
            reorderMode ? "check" : "format_line_spacing"
          }}</mat-icon> -->
          <span *ngIf="!isLoading">{{
            reorderMode ? "Submit" : "Re-Order"
          }}</span>
          <mat-spinner *ngIf="isLoading" diameter="24"></mat-spinner>
        </button>

        <button
          class="add_button"
          mat-raised-button
          color="primary"
          (click)="openUploadDialog()"
        >
          <i class="fa-solid fa-plus"></i>
          <span translate>Add Banners</span>
        </button>
      </div>
    </div>
  </div>
  <div class="list-container mt-3 table-container">
    <div
      *ngIf="bannersData?.length === 0"
      class="empty-data list-container d-flex flex-column justify-content-center align-items-center"
    >
      <i class="fa-solid fa-inbox empty-icon"></i>
      <p translate>No Data found</p>
    </div>
    <table
      mat-table
      [dataSource]="bannersData"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
      *ngIf="bannersData.length"
    >
      <!-- Drag Column -->
      <ng-container matColumnDef="drag">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="reorderMode">
            <mat-icon class="drag-handle" cdkDragHandle
              >drag_indicator</mat-icon
            >
          </ng-container>
        </td>
      </ng-container>

      <!-- Sl. No. -->
      <ng-container matColumnDef="sl.no">
        <th translate mat-header-cell *matHeaderCellDef>Sl. No.</th>
        <td mat-cell *matCellDef="let element">{{ element.sequence }}</td>
      </ng-container>

      <!-- From Date -->
      <ng-container matColumnDef="fromDate">
        <th translate mat-header-cell *matHeaderCellDef>From Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.visible_from | date: "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <!-- To Date -->
      <ng-container matColumnDef="toDate">
        <th translate mat-header-cell *matHeaderCellDef>To Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.visible_until | date: "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <!-- Image Name -->
      <ng-container matColumnDef="info">
        <th translate mat-header-cell *matHeaderCellDef>Image Name</th>
        <td mat-cell *matCellDef="let element">{{ element.image_name }}</td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th translate mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
      </ng-container>

      <!-- Image Preview -->
      <ng-container matColumnDef="images">
        <th translate mat-header-cell *matHeaderCellDef>Image</th>
        <td mat-cell *matCellDef="let element">
          <img
            [src]="imagePath + '/' + element.image_url"
            alt="Banner"
            class="banner-image"
          />
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th translate mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex justify-content-evenly align-items-center">
            <p translate (click)="viewItem(element)" class="m-0 cursor_pointer">
              View
            </p>
            <p
              mat-icon-button
              [matMenuTriggerFor]="menu"
              class="m-0 cursor_pointer"
            >
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </p>
          </div>
          <mat-menu #menu="matMenu">
            <p translate class="m-0" mat-menu-item (click)="editItem(element)">
              Edit
            </p>
            <p
              translate
              class="m-0"
              mat-menu-item
              (click)="deleteApi(element.id)"
            >
              Delete
            </p>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        cdkDrag
        [cdkDragDisabled]="!reorderMode"
        class="table-row"
      ></tr>
    </table>
  </div>
</section>
